// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"71aca89e","787":"8f4b3dc7"}[chunkId] + ".chunk.js";
};